export enum StatoPresaVisioneTimesheetEnum {
  Non_Presa = 1,
  Presa,
}
